import { Button, ButtonProps } from "antd";
import React from "react";
import styles from "./DropdownChildButton.module.less";

type PropsDropdownChildButton = Omit<ButtonProps, "className">;

export const DropdownChildButton: React.FC<PropsDropdownChildButton> = ({
  ...props
}) => <Button {...props} className={styles.button} />;
